import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {AdditionalPointEditComponent} from "./edit/additional-point-edit.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider.when('/company/:companyId/additionalPoint/:id', {template: ''});
    }]);
/***/

const addPointOfSaleRoutes: Routes = [
    {path: 'company/:companyId/additionalPoint/:id', component: AdditionalPointEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/additionalPoint/:id', component: AdditionalPointEditComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(addPointOfSaleRoutes)
    ],
    exports: [
        RouterModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AdditionalPointRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/additionalPoint/additional-point-routing.module.ts